import BlockHeader from '@pelckmans/elementis/components/blockheader';
import PinAltIcon from '@pelckmans/elementis/icons/pin-alt';
import Toggle from '@pelckmans/elementis/components/toggle';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PinnedMaterialContext from '../../_contexts/PinnedMaterialContext';
import PinnedMaterialCard from './PinnedMaterialCard';

export default function PinnedMaterialSection() {
  const { t } = useTranslation();

  const { pinnedMaterialList, showPinned, handleShowPinned } = useContext(PinnedMaterialContext);

  if (pinnedMaterialList.length === 0) return null;

  return (
    <section className="pinned-material-section">
      <BlockHeader
        toggle={
          <Toggle
            label={t('PAGES.TOC_LEVEL.PINNED_MATERIAL.TOGGLE_SELECT')}
            checked={showPinned}
            onChange={handleShowPinned}
          />
        }
        title={t('PAGES.TOC_LEVEL.PINNED_MATERIAL.TITLE')}
        titleTag="h2"
        icon={<PinAltIcon />}
      />
      <div className="pinned-material-container">
        {pinnedMaterialList.map(material => (
          <PinnedMaterialCard key={material.id} material={material} disabled={showPinned} pinnable={showPinned} />
        ))}
      </div>
    </section>
  );
}
